
export const DOCS_PREFIX = "/docs"
